export class CartRemoveButton extends HTMLElement {
    constructor() {
        super();

        this.addEventListener("click", (event) => {
            event.preventDefault();
            const cartItems =
                this.closest("cart-items") || this.closest("cart-drawer-items");
            if (this.dataset.gwp) {
                sessionStorage.setItem("gwpRemoved", true);
            }
            cartItems.updateQuantity(this.dataset.index, 0, null);
        });
    }
}

export class CartItems extends HTMLElement {
    constructor() {
        super();

        this.selectors = {
            quantityInput: "[js-quantity-input]",
            checkoutBtn: "[js-checkout-btn]",
            sampleCheckbox: "[js-sample-checkbox]",
            removeBundleTrigger: "[js-remove-bundle-trigger]",
        };

        // const debouncedOnChange = theme.utils.debounce((event) => {
        //   this.onChange(event);
        // }, 300);

        // this.addEventListener('change', debouncedOnChange.bind(this));
    }

    cartUpdateUnsubscriber = undefined;

    connectedCallback() {
        this.cartUpdateUnsubscriber = theme.utils.subscriptions.subscribe(
            window.PUB_SUB_EVENTS.cartUpdate,
            (event) => {
                if (event.source === "cart-items") {
                    return;
                }
                this.onCartUpdate();
            },
        );

        this.quantityInputs = this.querySelectorAll(
            this.selectors.quantityInput,
        );
        if (this.quantityInputs) {
            this.quantityInputs.forEach((input) => {
                input.addEventListener("change", this.onChange);
            });
        }

        this.checkoutBtn = this.querySelector(this.selectors.checkoutBtn);
        if (this.dataset.samplesEnabled && this.checkoutBtn) {
            this.checkoutBtn.addEventListener("click", this.evaluateSamples);
            this.sampleCheckboxes = this.querySelectorAll(
                this.selectors.sampleCheckbox,
            );
        }

        this.removeBundleTrigger = this.querySelector(
            this.selectors.removeBundleTrigger,
        );
        if (this.removeBundleTrigger) {
            this.removeBundleTrigger.addEventListener(
                "click",
                this.removeBundle,
            );
        }

        this.refreshGwp();
        this.checkSamplesInCart();
    }

    disconnectedCallback() {
        if (this.cartUpdateUnsubscriber) {
            this.cartUpdateUnsubscriber();
        }
    }

    evaluateSamples = async (evt) => {
        evt.preventDefault();

        var formData = {
            items: [],
            sections: this.getSectionsToRender().map(
                (section) => section.section,
            ),
        };
        for (let i = 0; i < this.sampleCheckboxes.length; i++) {
            if (this.sampleCheckboxes[i].checked) {
                const variantId = this.sampleCheckboxes[i].dataset.variantId;
                formData.items.push({
                    id: variantId,
                    quantity: 1,
                    properties: {
                        _sample: true,
                    },
                });
            }
        }

        if (formData.items.length > 0) {
            await this.updateCartSamples(formData);
        } else {
            window.location.href = "/checkout";
        }
    };

    async updateCartSamples(formData) {
        fetch(`${window.routes.cart_add_url}`, {
            method: "POST",
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
            },
            body: JSON.stringify(formData),
        })
            .then((response) => {
                return response.json();
            })
            .then((_data) => {
                window.location.href = "/checkout";
            })
            .catch((error) => {
                console.error("Error:", error);
            });
    }

    async fetchCart() {
        return fetch(`${window.routes.cart_url}`, {
            method: "POST",
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
            },
        })
            .then((response) => {
                return response.json();
            })
            .then((data) => {
                return data;
            })
            .catch((error) => {
                console.error("Error:", error);
            });
    }

    async updateCart(updateData) {
        const results = fetch(`${window.routes.cart_update_url}`, {
            method: "POST",
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
            },
            body: JSON.stringify(updateData),
        })
            .then((response) => response.text())
            .then((state) => {
                const parsedState = JSON.parse(state);
                this.refreshGwp(parsedState);
                this.getSectionsToRender().forEach((section) => {
                    if (document.getElementById(section.id)) {
                        const elementToReplace =
                            document
                                .getElementById(section.id)
                                .querySelector(section.selector) ||
                            document.getElementById(section.id);
                        elementToReplace.innerHTML = this.getSectionInnerHTML(
                            parsedState.sections[section.section],
                            section.selector,
                        );
                    }
                });
                this.connectedCallback();
            })
            .catch((error) => {
                console.log(error);
                this.querySelectorAll(".loading-overlay").forEach((overlay) => {
                    overlay.classList.add("hidden");
                });
                const errors =
                    document.getElementById("CartPage-CartErrors") ||
                    document.getElementById("CartDrawer-CartErrors");
                errors.textContent = `There was an error while updating your cart. Please try again.`;
            });
        return results;
    }

    checkSamplesInCart = async () => {
        var samplesInCart = 0;
        var nonSampleInCart = 0;
        const sampleInCart = {};

        var data = await this.fetchCart();
        data.items.forEach((item) => {
            if (item.properties._sample) {
                samplesInCart++;
                sampleInCart[item.key] = 0;
            } else {
                nonSampleInCart++;
            }
        });
        if (samplesInCart > 0 && nonSampleInCart === 0) {
            const updateData = {
                updates: sampleInCart,
                sections: this.getSectionsToRender().map(
                    (section) => section.section,
                ),
                sections_url: window.location.pathname,
            };
            this.updateCart(updateData);
        }
    };

    refreshGwp(parsedState) {
        if (this.dataset.gwpEnabled !== "true") return;

        const variantId = this.dataset.gwpVariantId;
        const cart = document.querySelector("cart-drawer");
        const sectionId =
            document.getElementById("CartPage-CartItems")?.dataset?.id;
        const section =
            parsedState?.sections?.cart || parsedState?.sections?.[sectionId];

        // update action
        if (section) {
            const parsedHtml = new DOMParser().parseFromString(
                section,
                "text/html",
            );
            const component =
                parsedHtml.querySelector("cart-drawer-items") ||
                parsedHtml.querySelector("cart-items");
            if (component) {
                this.dataset.gwpAction =
                    component.getAttribute("data-gwp-action");
            }
        }

        switch (this.dataset.gwpAction) {
            case "add": {
                if (sessionStorage.getItem("gwpRemoved") !== "true") {
                    const body = JSON.stringify({
                        items: [
                            {
                                id: variantId,
                                quantity: 1,
                                properties: { _gwp: true },
                            },
                        ],
                        sections: this.getSectionsToRender().map(
                            (section) => section.section,
                        ),
                        sections_url: window.location.pathname,
                    });

                    fetch(`${window.routes.cart_add_url}`, {
                        ...{
                            method: "POST",
                            headers: {
                                "Content-Type": "application/json",
                                Accept: `application/json`,
                            },
                        },
                        ...{ body },
                    })
                        .then((data) => data.json())
                        .then((data) => {
                            if (window.location.pathname === "/cart") {
                                this.getSectionsToRender().forEach(
                                    (section) => {
                                        const elementToReplace =
                                            document
                                                .getElementById(section.id)
                                                .querySelector(
                                                    section.selector,
                                                ) ||
                                            document.getElementById(section.id);
                                        elementToReplace.innerHTML =
                                            this.getSectionInnerHTML(
                                                data.sections[section.section],
                                                section.selector,
                                            );
                                    },
                                );
                            } else {
                                cart.renderContents(data);
                            }
                        });
                }
                break;
            }

            case "remove": {
                const body = JSON.stringify({
                    id: variantId,
                    quantity: 0,
                    sections: this.getSectionsToRender().map(
                        (section) => section.section,
                    ),
                    sections_url: window.location.pathname,
                });
                fetch(`${window.routes.cart_change_url}`, {
                    ...{
                        method: "POST",
                        headers: {
                            "Content-Type": "application/json",
                            Accept: `application/json`,
                        },
                    },
                    ...{ body },
                })
                    .then((data) => data.json())
                    .then((data) => {
                        if (window.location.pathname === "/cart") {
                            this.getSectionsToRender().forEach((section) => {
                                const elementToReplace =
                                    document
                                        .getElementById(section.id)
                                        .querySelector(section.selector) ||
                                    document.getElementById(section.id);
                                elementToReplace.innerHTML =
                                    this.getSectionInnerHTML(
                                        data.sections[section.section],
                                        section.selector,
                                    );
                            });
                        } else {
                            cart.renderContents(data);
                        }
                    });
                break;
            }
            default:
                break;
        }
    }

    onChange = (event) => {
        this.updateQuantity(
            event.target.dataset.index,
            event.target.value,
            document.activeElement.getAttribute("name"),
        );
    };

    onCartUpdate() {
        fetch(`${routes.cart_url}?section_id=cart__main`)
            .then((response) => response.text())
            .then((responseText) => {
                const html = new DOMParser().parseFromString(
                    responseText,
                    "text/html",
                );
                const sourceQty = html.querySelector("cart-items");
                this.innerHTML = sourceQty.innerHTML;
                this.refreshGwp();
                this.connectedCallback();
            })
            .catch((e) => {
                console.error(e);
            });
    }

    getSectionsToRender() {
        return [
            {
                id: "CartPage-CartItems",
                section:
                    document.getElementById("CartPage-CartItems").dataset.id,
                selector: "[js-cart-page-contents]",
            },
        ];
    }

    updateQuantity(line, quantity, name) {
        this.enableLoading(line);

        const body = JSON.stringify({
            line,
            quantity,
            sections: this.getSectionsToRender().map(
                (section) => section.section,
            ),
            sections_url: window.location.pathname,
        });

        fetch(`${routes.cart_change_url}`, {
            ...{
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    Accept: `application/json`,
                },
            },
            ...{ body },
        })
            .then((response) => {
                return response.text();
            })
            .then((state) => {
                const parsedState = JSON.parse(state);
                this.refreshGwp(parsedState);
                const quantityElement =
                    document.getElementById(`Quantity-${line}`) ||
                    document.getElementById(`Drawer-quantity-${line}`);
                const items = document.querySelectorAll("[js-cart-item]");

                if (parsedState.errors) {
                    quantityElement.value =
                        quantityElement.getAttribute("value");
                    this.updateLiveRegions(line, parsedState.errors);
                    return;
                }

                const cartDrawerWrapper = document.querySelector("cart-drawer");

                this.getSectionsToRender().forEach((section) => {
                    if (document.getElementById(section.id)) {
                        const elementToReplace =
                            document
                                .getElementById(section.id)
                                .querySelector(section.selector) ||
                            document.getElementById(section.id);
                        elementToReplace.innerHTML = this.getSectionInnerHTML(
                            parsedState.sections[section.section],
                            section.selector,
                        );
                    }
                });
                const updatedValue = parsedState.items[line - 1]
                    ? parsedState.items[line - 1].quantity
                    : undefined;
                let message = "";
                if (
                    items.length === parsedState.items.length &&
                    updatedValue !== parseInt(quantityElement.value, 10)
                ) {
                    if (typeof updatedValue === "undefined") {
                        message = `There was an error while updating your cart. Please try again.`;
                    } else {
                        message = `You can only add ${updatedValue} of this item to your cart.`;
                    }
                }
                this.updateLiveRegions(line, message);

                const lineItem =
                    document.getElementById(`CartItem-${line}`) ||
                    document.getElementById(`CartDrawer-Item-${line}`);
                if (lineItem?.querySelector(`[name="${name}"]`)) {
                    cartDrawerWrapper
                        ? theme.utils.a11y.trapFocus(
                              cartDrawerWrapper,
                              lineItem.querySelector(`[name="${name}"]`),
                          )
                        : lineItem.querySelector(`[name="${name}"]`).focus();
                } else if (parsedState.item_count === 0 && cartDrawerWrapper) {
                    theme.utils.a11y.trapFocus(
                        cartDrawerWrapper.querySelector("[js-empty-cart]"),
                        cartDrawerWrapper.querySelector(
                            "[js-cart-continue-link]",
                        ),
                    );
                } else if (
                    document.querySelector("[js-cart-item]") &&
                    cartDrawerWrapper
                ) {
                    theme.utils.a11y.trapFocus(
                        cartDrawerWrapper,
                        document.querySelector("[js-cart-item-image]"),
                    );
                }
                theme.utils.subscriptions.publish(
                    window.PUB_SUB_EVENTS.cartUpdate,
                    { source: "cart-items" },
                );
                this.connectedCallback();
            })
            .catch((error) => {
                console.log(error);
                this.querySelectorAll(".loading-overlay").forEach((overlay) => {
                    overlay.classList.add("hidden");
                });
                const errors =
                    document.getElementById("cart-errors") ||
                    document.getElementById("CartDrawer-CartErrors");
                errors.textContent = `There was an error while updating your cart. Please try again.`;
            })
            .finally(() => {
                this.disableLoading(line);
            });
    }

    updateLiveRegions(line, message) {
        const lineItemError =
            document.getElementById(`Line-item-error-${line}`) ||
            document.getElementById(`CartDrawer-LineItemError-${line}`);
        if (lineItemError) lineItemError.innerHTML = message;
    }

    getSectionInnerHTML(html, selector) {
        return new DOMParser()
            .parseFromString(html, "text/html")
            .querySelector(selector).innerHTML;
    }

    enableLoading(line) {
        const mainCartItems =
            document.getElementById("CartPage-CartItems") ||
            document.getElementById("CartDrawer-CartItems");
        mainCartItems.classList.add("cart__items--disabled");

        const cartItemElements = this.querySelectorAll(
            `#CartItem-${line} loading-spinner`,
        );
        const cartDrawerItemElements = this.querySelectorAll(
            `#CartDrawer-Item-${line} loading-spinner`,
        );

        [...cartItemElements, ...cartDrawerItemElements].forEach((spinner) => {
            spinner.setAttribute("loading", "");
        });

        document.activeElement.blur();
    }

    disableLoading(line) {
        const mainCartItems =
            document.getElementById("CartPage-CartItems") ||
            document.getElementById("CartDrawer-CartItems");
        mainCartItems.classList.remove("cart__items--disabled");

        const cartItemElements = this.querySelectorAll(
            `#CartItem-${line} loading-spinner`,
        );
        const cartDrawerItemElements = this.querySelectorAll(
            `#CartDrawer-Item-${line} loading-spinner`,
        );

        [...cartItemElements, ...cartDrawerItemElements].forEach((spinner) => {
            spinner.removeAttribute("loading");
        });
    }

    removeBundle = (event) => {
        event.preventDefault();
        this.cart = document.querySelector("cart-drawer");
        this.cartPage = document.querySelector("cart-items");

        const updates = {};

        document.querySelectorAll("[js-cart-item]").forEach((item) => {
            if (item.dataset.itemId) {
                updates[parseInt(item.dataset.itemId, 10)] = 0;
            }
        });

        fetch(`${window.Shopify.routes.root}cart/update.js`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({ updates }),
        })
            .then((response) => response.json())
            .then((response) => {
                if (response.status) {
                    this._handleErrorMessage(response.description);
                    return;
                }
                if (this.cartPage) this.cartPage.onCartUpdate();
                if (this.cart) this.cart.renderContents(response);
            })
            .catch((error) => {
                console.error("Error:", error);
            });
    };
}

export class CartNote extends HTMLElement {
    constructor() {
        super();

        this.addEventListener(
            "change",
            debounce((event) => {
                const body = JSON.stringify({ note: event.target.value });
                fetch(`${routes.cart_update_url}`, {
                    ...{
                        method: "POST",
                        headers: {
                            "Content-Type": "application/json",
                            Accept: `application/json`,
                        },
                    },
                    ...{ body },
                });
            }, ON_CHANGE_DEBOUNCE_TIMER),
        );
    }
}

export class CartDrawer extends HTMLElement {
    renderContents(parsedState) {
        this.productId = parsedState.id;

        this.getSectionsToRender().forEach((section) => {
            const sectionElement = section.selector
                ? document.querySelector(section.selector)
                : document.getElementById(section.id);
            sectionElement.innerHTML = this.getSectionInnerHTML(
                parsedState.sections[section.id],
                section.selector,
            );
        });
    }

    getSectionInnerHTML(html, selector = ".shopify-section") {
        return new DOMParser()
            .parseFromString(html, "text/html")
            .querySelector(selector).innerHTML;
    }

    getSectionsToRender() {
        return [
            {
                id: "cart",
                selector: "#cart",
            },
        ];
    }

    getSectionDOM(html, selector = ".shopify-section") {
        return new DOMParser()
            .parseFromString(html, "text/html")
            .querySelector(selector);
    }

    setActiveElement(element) {
        this.activeElement = element;
    }
}

export class CartDrawerItems extends CartItems {
    getSectionsToRender() {
        return [
            {
                id: "cart",
                section: "cart",
                selector: "[js-cart-drawer-contents]",
            },
        ];
    }
}

export class CartUpsell extends HTMLElement {
    constructor() {
        super();

        this.selectors = {
            quickAddSingleVariant: "[js-quick-add-single]",
        };
    }

    connectedCallback() {
        this._quickAddSingleVariant = this.querySelector(
            this.selectors.quickAddSingleVariant,
        );
        this.cart = document.querySelector("cart-drawer");
        this.cartPage = document.querySelector("cart-items");

        this._initQuickAdd();
    }

    _initQuickAdd() {
        if (this._quickAddSingleVariant != null) {
            this._quickAddSingleVariant.addEventListener(
                "click",
                this._submitSingle.bind(this),
            );
        }
    }

    _submitSingle(e) {
        e.preventDefault();
        const variantId = e.target.dataset.variantId;
        this.cart.setActiveElement(document.activeElement);

        const data = {
            items: [
                {
                    id: variantId,
                    quantity: 1,
                },
            ],
            sections: this.getSectionsToRender().map(
                (section) => section.section,
            ),
        };

        fetch(`${window.Shopify.routes.root}cart/add.js`, {
            method: "POST",
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
            },
            body: JSON.stringify(data),
        })
            .then((response) => response.json())
            .then((response) => {
                if (response.status) {
                    this._handleErrorMessage(response.description);
                    return;
                }

                if (this.cartPage) this.cartPage.onCartUpdate();
                this.cart.renderContents(response);
            })
            .catch((error) => {
                console.error("Error:", error);
            });
    }

    getSectionsToRender() {
        return [
            {
                id: "cart",
                section: "cart",
                selector: "[js-cart-drawer-contents]",
            },
            {
                id: "cart-count",
                section: "cart-count",
                selector: ".shopify-section",
            },
        ];
    }
}
